import { ApiCall } from 'omni-common-ui';
import { fetch, buildUrl } from 'domain/Api';
import HomeworkContent from './model';

export const FETCH_HOMEWORK_CONTENT_REQUEST = 'FETCH_HOMEWORK_CONTENT_REQUEST';
export const FETCH_HOMEWORK_CONTENT_SUCCESS = 'FETCH_HOMEWORK_CONTENT_SUCCESS';
export const FETCH_HOMEWORK_CONTENT_FAILURE = 'FETCH_HOMEWORK_CONTENT_FAILURE';
export const ASSIGN_HOMEWORK_REQUEST = 'ASSIGN_HOMEWORK_REQUEST';
export const ASSIGN_HOMEWORK_SUCCESS = 'ASSIGN_HOMEWORK_SUCCESS';
export const ASSIGN_HOMEWORK_FAILURE = 'ASSIGN_HOMEWORK_FAILURE';

const buildHomeworkContentUrl = (sessionId) => buildUrl(`/sessions/${sessionId}/homework-content`);

export function fetchHomeworkContentIfNeeded(sessionId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildHomeworkContentUrl(sessionId) })) {
      return false;
    }

    return dispatch(fetchHomeworkContent(sessionId));
  };
}

export function fetchHomeworkContent(sessionId) {
  return (dispatch) => {
    const url = buildHomeworkContentUrl(sessionId);
    const method = 'GET';

    return dispatch(fetchHomeworkContentRequest()).payload
      .then((response) => dispatch(fetchHomeworkContentSuccess(response)))
      .catch((error) => dispatch(fetchHomeworkContenttFailure(error)));

    function fetchHomeworkContentRequest() {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
      });
    }

    function fetchHomeworkContentSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_SUCCESS,
        payload: response,
        url,
        method,
        sessionId,
      });
    }

    function fetchHomeworkContenttFailure(error) {
      return ApiCall.createAction({
        type: FETCH_HOMEWORK_CONTENT_FAILURE,
        url,
        method,
        sessionId,
        error,
      });
    }
  };
}

export function assignHomeworkContent(sessionId, editedGroupHomeworkItems) {
  return (dispatch) => {
    const url = buildHomeworkContentUrl(sessionId);
    const method = 'PUT';

    return dispatch(assignHomeworkContentRequest()).payload
      .then(() => dispatch(assignHomeworkContentSuccess()))
      .catch((error) => dispatch(assignHomeworkContentFailure(error)));

    function assignHomeworkContentRequest() {
      const request = fetch(url,
        {
          method,
          body: JSON.stringify(
              HomeworkContent.serialize(editedGroupHomeworkItems)),
        }
      );
      return ApiCall.createAction({
        type: ASSIGN_HOMEWORK_REQUEST,
        payload: request,
        url,
        method,
        sessionId,
        editedGroupHomeworkItems,
      });
    }

    function assignHomeworkContentSuccess() {
      return ApiCall.createAction({
        type: ASSIGN_HOMEWORK_SUCCESS,
        url,
        method,
        sessionId,
        editedGroupHomeworkItems,
      });
    }

    function assignHomeworkContentFailure(error) {
      return ApiCall.createAction({
        type: ASSIGN_HOMEWORK_FAILURE,
        url,
        method,
        error,
        sessionId,
        editedGroupHomeworkItems,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Homework/Content/actions.js